import { injectable } from 'inversify';
import { BuildConfig, IBuildConfigService } from '_c/typings/service/build-config';

@injectable()
export class BuildConfigService implements IBuildConfigService {
  config: BuildConfig = {
    env: import.meta.env.VITE_BUILD_ENV,
  };
}
